let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lx5kZ")).then(() => parcelRequire('7tcPf'));